import React from 'react'
import LoadingButton from '@mui/lab/LoadingButton';
import './style.scss'

function Button({ text, icon, onClick, type, btnLoading, buttonRef, apiBtnLoading, disabled, apiBtnDropLoading, customStyle }) {
    return (
        type === "submit" ? <LoadingButton style={customStyle} loading={btnLoading} type={type} variant="outlined" className='loadingBtn quote-form-button' disabled={disabled}> {btnLoading ? "" : "Submit"} </LoadingButton> : <button type={type} className='quote-form-button' ref={buttonRef} style={customStyle} onClick={onClick} disabled={disabled || apiBtnDropLoading}><span>{text}{(icon && !apiBtnLoading && !apiBtnDropLoading) ? <img src={icon} /> : <></>}</span></button>
    )
}

export default Button;